var formSetup = {
  forms: {
    NewCompetition: {
      title: "Add New Competition",
      titletranslation: "competition.add",
      endpoint: "v1/#sport/o/#0/competitions",
      parameters: ["organizationId"],
      method: "POST",
      successmessage: "New Competition added successfully.",
      link: {
        show: false,
        message: "View Competition",
        path: "/admin/competitions/",
        parameters: []
      },
      submit: "Add New Competition",
      submittranslation: "competition.add",
      fields: [
        {
          name: "nameLocal",
          size: "col-sm-4 col",
          label: "Local Name:",
          labeltranslation: "name.local",
          type: "text",
          placeholder: "Local Name",
          className: "form-control",
          required: true,
          initial: null,
          maxLength: 150,
          errors: {
            maxLength: "Max 150 characters",
            required: "Local Name Is Required"
          }
        },
        {
          name: "abbreviationLocal",
          size: "col-sm-2 col",
          label: "Local Abbr:",
          labeltranslation: "name.local.abbreviation",
          type: "text",
          placeholder: "Local Abbr",
          className: "form-control",
          required: false,
          initial: null,
          maxLength: 50,
          errors: {
            maxLength: "Max 50 characters",
            required: "Local Name Is Required"
          }
        },
        {
          name: "nameLatin",
          size: "col-sm-4 col",
          label: "Latin Name:",
          labeltranslation: "name.latin",
          type: "text",
          placeholder: "Latin Name",
          className: "form-control",
          required: false,
          initial: null,
          maxLength: 150,
          errors: {
            maxLength: "Max 150 characters",
            required: "Latin Name Is Required"
          }
        },
        {
          name: "abbreviationLatin",
          size: "col-sm-2 col",
          label: "Latin Abbr:",
          labeltranslation: "name.latin.abbreviation",
          type: "text",
          placeholder: "Latin Abbr",
          className: "form-control",
          required: false,
          initial: null,
          maxLength: 50,
          errors: {
            maxLength: "Max 50 characters",
            required: "Local Name Is Required"
          }
        },
        {
          name: "internationalReference",
          size: "col-sm-6 col",
          label: "International Reference",
          labeltranslation: "international.reference",
          type: "text",
          placeholder: "",
          className: "form-control",
          required: false,
          initial: null,
          errors: {
            required: "Country Is Required"
          }
        },
        {
          name: "leagueId",
          size: "col-sm-6 col",
          label: "League:",
          labeltranslation: "league",
          type: "lookup",
          placeholder: "League",
          className: "form-control",
          required: false,
          initial: null,
          lookup: {
            endpoint: "v1/#sport/o/#0/leagues",
            text: "nameLocal",
            value: "leagueId",
            parameters: ["organizationId"]
          },
          errors: {
            required: "League Is Required"
          }
        }
      ]
    },
    EditCompetition: {
      title: "Edit Competition",
      titletranslation: "competition.update",
      endpoint: "v1/#sport/o/#0/competitions/#1",
      parameters: ["organizationId", "competitionId"],
      method: "PUT",
      successmessage: "Competition updated successfully.",
      link: {
        show: false,
        message: "View Competition",
        path: "/configuration/competitions/",
        parameters: []
      },
      submit: "Update Competition",
      submittranslation: "competition.update",
      fields: [
        {
          name: "nameLocal",
          size: "col-sm-4 col",
          label: "Local Name:",
          labeltranslation: "name.local",
          type: "text",
          placeholder: "Local Name",
          className: "form-control",
          required: true,
          initial: "nameLocal",
          errors: {
            required: "Local Name Is Required"
          }
        },
        {
          name: "abbreviationLocal",
          size: "col-sm-2 col",
          label: "Local Abbr:",
          type: "text",
          placeholder: "Local Abbr",
          labeltranslation: "name.local.abbreviation",
          className: "form-control",
          required: false,
          initial: "abbreviationLocal",
          errors: {
            required: "Local Name Is Required"
          }
        },
        {
          name: "nameLatin",
          size: "col-sm-4 col",
          label: "Latin Name:",
          type: "text",
          placeholder: "Latin Name",
          labeltranslation: "name.latin",
          className: "form-control",
          required: false,
          initial: "nameLatin",
          errors: {
            required: "Latin Name Is Required"
          }
        },
        {
          name: "abbreviationLatin",
          size: "col-sm-2 col",
          label: "Latin Abbr:",
          labeltranslation: "name.latin.abbreviation",
          type: "text",
          placeholder: "Latin Abbr",
          className: "form-control",
          required: false,
          initial: "abbreviationLatin",
          errors: {
            required: "Local Name Is Required"
          }
        },
        {
          name: "internationalReference",
          size: "col-sm-6 col",
          label: "International Reference",
          labeltranslation: "international.reference",
          type: "text",
          placeholder: "",
          className: "form-control",
          required: false,
          initial: "internationalReference",
          errors: {
            required: "Country Is Required"
          }
        },
        {
          name: "leagueId",
          size: "col-sm-6 col",
          label: "League:",
          labeltranslation: "league",
          type: "lookup",
          placeholder: "League",
          className: "form-control",
          required: false,
          initial: "leagueId",
          lookup: {
            endpoint: "v1/#sport/o/#0/leagues",
            text: "nameLocal",
            value: "leagueId",
            parameters: ["organizationId"]
          },
          errors: {
            required: "League Is Required"
          }
        }
      ]
    }
  }
};
export default formSetup;
